import { Routes } from '@angular/router';

export const tyresRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@app/admin/tyres/overview/overview.component').then(component => component.OverviewComponent),
  },
];
